// src/components/shared/CalculatorIcon.tsx
import React from "react";

interface CalculatorIconProps {
  onClick: () => void;
  className?: string;
  tooltip?: string;
}

const CalculatorIcon: React.FC<CalculatorIconProps> = ({
  onClick,
  className = "",
  tooltip = "למחשבון ציון ירוק",
}) => {
  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center justify-center w-6 h-6 ml-2 text-green-600 bg-green-100 rounded-full cursor-pointer hover:bg-green-200 transition-colors focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 ${className}`}
      title={tooltip}
      aria-label={tooltip}
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="currentColor"
        className="text-green-600"
      >
        <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-2h2v2zm0-4H7v-2h2v2zm0-4H7V7h2v2zm4 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2zm4 8h-2v-6h2v6zm0-8h-2V7h2v2z" />
      </svg>
    </button>
  );
};

export default CalculatorIcon;
